var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pdfContainer"},[_c('loading',{attrs:{"active":_vm.loading,"is-full-page":_vm.fullpage,"height":80,"width":80},on:{"update:active":function($event){_vm.loading=$event}}}),_c('div',{staticStyle:{"height":"100vh"},attrs:{"id":"iframewrapper"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }